<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Version</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>API Version</label>
          <input class="form-control" [(ngModel)]="apiVersion" placeholder="1.0.0" type="text">
        </div>
        <div class="form-group mb-3">
          <label>Min App Version</label>
          <input class="form-control" [(ngModel)]="minAppVersion" placeholder="1.0.0" type="text">
        </div>
        <div class="form-group mb-3">
          <label>Game Server Version</label>
          <input class="form-control" [(ngModel)]="gameServerVersion" placeholder="1.0.0" type="text">
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isActive" id="isActiveAdd">
          <label class="form-check-label" for="isActiveAdd">Active</label>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
